import { BookingDetails, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { ApplierOption } from './ApplierOption';
import { onlyUnique } from './ArrayHelper';
import { IsReturnCollection, IsSmartSend } from './SmartSendSummaryGenerator';

export function GenerateSmartSendUpdateModel(item: SmartSendItemApiModel, fields: ApplierOption[]) {
  if (!IsSmartSend(item)) {
    throw 'Not Smart Send';
  }

  const model = {
    Id: item.Id,
    CustomerId: item.CustomerId,
    Status: item.Status,
    MarketplaceStatus: item.MarketplaceStatus
  } as SmartSendItemApiModel;

  // ServiceOption updates require Extras to be persisted.
  if (fields.includes('ServiceOption')) {
    fields.push('Extras');
  }

  if (fields.includes('Recipient') || fields.includes('RecipientContactDetails')) {
    model.Recipient = item.Recipient;
  }

  if (fields.includes('Sender')) {
    model.Sender = item.Sender;
  }

  if (fields.includes('Extras') || fields.includes('Protection')) {
    model.Extras = item.Extras;
  }

  if (fields.includes('Service')) {
    model.Service = item.Service;
  }

  if (fields.includes('Meta')) {
    model.Meta = item.Meta;
  }

  if (fields.includes('Consignment')) {
    model.Consignment = item.Consignment;
  }

  if (fields.includes('MarketplaceOrderLines')) {
    model.MarketplaceOrderLines = item.MarketplaceOrderLines;
  }

  if (fields.includes('Dimensions')) {
    model.PackageDimensions = item.PackageDimensions;
  }

  if (fields.includes('Tags') || IsReturnCollection(item)) {
    model.Tags = item.Tags;
  }

  if (fields.includes('Owners')) {
    model.Owners = item.Owners;
  }

  if (fields.includes('PreferredCollectionDate')) {
    model.PreferredCollectionDate = item.PreferredCollectionDate;
  }

  if (fields.includes('MarkAsDispatched')) {
    // Legacy
    if (item.BookingDetails) {
      model.BookingDetails = {
        OrderId: item.BookingDetails.OrderId,
        OrderLineId: item.BookingDetails.OrderLineId
      } as BookingDetails;
    }
    // Update to use info from Ol Sources
    if (!model.MarketplaceOrderLines && item.MarketplaceOrderLines) {
      model.MarketplaceOrderLines = item.MarketplaceOrderLines;
    }
    model.Source = item.Source;
  }

  return { Item: SanitiseSmartSendItem(model), Changes: fields.filter(onlyUnique) };
}

export function SanitiseSmartSendItem(item: SmartSendItemApiModel): SmartSendItemApiModel {
  const i: SmartSendItemApiModel = JSON.parse(JSON.stringify(item));

  if (i.MarketplaceOrderLines) {
    i.MarketplaceOrderLines.forEach((x) => {
      x.OrderLink = '';
      if (x.Product) {
        x.Product.ImageUrl = '';
        x.Product.ProductLink = '';
      }
    });
  }

  i.State = null;

  return i;
}
